'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatcher = undefined;

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _dispatcher;

exports.collectionMiddleware = collectionMiddleware;

var _reduxGraph = require('redux-graph');

var _actions = require('./actions');

var _const = require('./const');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var dispatcher = exports.dispatcher = (_dispatcher = {}, _defineProperty(_dispatcher, _actions.CREATE_LIST, _reduxGraph.entityPut), _defineProperty(_dispatcher, _actions.UPDATE_ITEM, _reduxGraph.entityUpdate), _dispatcher);

function collectionMiddleware() {
  return function (next) {
    return function (action) {
      if ((0, _isFunction3.default)(dispatcher[action.type])) {
        return next(dispatcher[action.type](action.payload));
      }
      if (action.type === _actions.CREATE_ITEM) {
        var item = next((0, _reduxGraph.entityPut)((0, _omit3.default)(action.payload, 'mainEntity')));
        next((0, _reduxGraph.triplePut)({
          subject: action.payload.mainEntity, predicate: _const.PREDICATE, object: item.payload
        }));
        return item;
      }
      return next(action);
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-collection/lib/middleware.js
// module id = 837
// module chunks = 0